import { QueryClient } from '@tanstack/react-query';

// Shared React Query client. Sensible defaults for a dashboard app: cache for a
// minute, don't refetch on every window focus, retry once.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
